module.exports = __webpack_public_path__ + "media/images/proposal/top/proposal-top-main-2cf653023761be5061a0d13d13726441.jpg";